import { useCompany } from './Company';
import { useNextGen } from './NextGen';

export const Company = {
  useCompany,
  useNextGen,
};
